// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__ordr7","modalFooterButton":"ModalNotes_modalFooterButton__2Pphs"};